/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

// Alias
import Search from '../../input/search';

export default Search;



// WEBPACK FOOTER //
// ./~/@salesforce/design-system-react/components/forms/input/search.jsx